module.exports = __webpack_public_path__ + "img/car-orange-vertical.66fc5bd1.svg";